机酒火首页加载中间页
<template minapp='mpx' xlang='wxml'>
  <view class="page-box blank-page-style">
    <!-- 数据加载中 -->
    <view class="loading-page" wx:if="{{type==='loading'}}">
      <image
        src="{{loadingImageUrl}}"
        alt="加载中"
        class="loading-img"
        wx:if="{{loadingImageUrl}}"
      ></image>
      <view class="context title">{{ loadingContext }}</view>
    </view>
    <!-- 品类加载中 目前只适用于首页 -->
    <view class="loading-page" wx:elif="{{type==='category-loading'}}">
      <view
        class="category-loading-center"
        wx:class="{{centerMoveUp ? 'category-loading-center-ios' : ''}}"
      >
        <image
          wx:if="{{loadingImageUrl}}"
          class="category-loading-img"
          src="{{loadingImageUrl}}"
        ></image>
        <view class="context title" wx:if="{{categoryLoadingTitle}}">{{
          categoryLoadingTitle
        }}</view>
        <view class="context desc" wx:if="{{categoryLoadingDesc}}">{{
          categoryLoadingDesc
        }}</view>
        <view class="loading-progress">
          <view
            wx:class="{{selectedIndex == 0?'circle-current':'circle-normal'}}"
            class="circle"
          ></view>
          <view
            wx:class="{{selectedIndex == 1?'circle-current':'circle-normal'}}"
            class="circle"
          ></view>
          <view
            wx:class="{{selectedIndex == 2?'circle-current':'circle-normal'}}"
            class="circle"
          ></view>
        </view>
      </view>
    </view>
    <!-- 无数据、加载失败 -->
    <view class="blank-page" wx:if="{{type==='blank-page'}}">
      <image
        wx:if="{{blankImageUrl}}"
        src="{{blankImageUrl}}"
        alt="无数据图片"
        class="blank-img"
      ></image>
      <view class="context">
        <slot name="blankContextTitle" wx:if="{{setBlankContext}}"> </slot>
        <view class="title" wx:else wx:style="{{blankTitleStyle}}">
          {{ blankContextTitle }}
        </view>
        <view
          class="sub-title"
          wx:if="{{hasSubTitle}}"
          wx:style="{{blankSubtitleStyle}}"
        >
          {{ blankContextSubTitle }}
        </view>
      </view>
      <view wx:if="{{hasButton}}">
        <view class="blank-button-Context" bindtap="clickButton">
          {{ blankButtonContext }}
        </view>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    classes: ['blank-page-style'],
    props: {
      type: {
        type: String,
        value: 'blank-page'
      },
      loadingContext: {
        type: String,
        value: '数据加载中...'
      },
      blankButtonContext: {
        type: String,
        value: '重试'
      },
      blankContextTitle: {
        type: String,
        value: '加载失败'
      },
      blankContextSubTitle: {
        type: String,
        value: '请检查网络设置或稍后重试'
      },
      loadingImageUrl: {
        type: String,
        value:
          'https://pt-starimg.didistatic.com/static/starimg/img/VY4SkVNwXT1644496067250.gif'
      },
      blankImageUrl: {
        type: String,
        value:
          'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
      },
      hasButton: {
        type: Boolean,
        value: true
      },
      hasSubTitle: {
        type: Boolean,
        value: true
      },
      hasTitle: {
        type: Boolean,
        value: true
      },
      setBlankContext: {
        type: Boolean,
        value: false
      },
      blankTitleStyle: {},
      blankSubtitleStyle: {},
      // 品类加载标题
      categoryLoadingTitle: {
        type: String,
        value: ''
      },
      // 品类加载描述
      categoryLoadingDesc: {
        type: String,
        value: ''
      }
    },
    data: {
      // 加载当前索引
      selectedIndex: 0,
      // 运行平台
      platform: ''
    },
    computed: {
      // 运行在iOS的小程序或h5时，整体居中向上一点
      centerMoveUp() {
        return (__mpx_mode__ === 'dd' && this.platform === 'ios') ||
          __mpx_mode__ == 'web'
          ? true
          : false
      }
    },

    methods: {
      clickButton() {
        this.$trigger('click-button')
      },
      startAnimation() {
        const timer = setInterval(() => {
          if (this.selectedIndex == undefined || this.selectedIndex == null) {
            clearInterval(timer)
          }
          if (this.selectedIndex == 2) {
            this.selectedIndex = 0
          } else {
            this.selectedIndex += 1
          }
        }, 350)
      }
    },
    created() {
      this.startAnimation()
      this.platform = mpx.getSystemInfoSync().platform
    }
  })
</script>

<style lang='stylus' scoped>
  .page-box
    height 100%
    background #ffffff
    overflow hidden
  .loading-page
    display flex
    align-items center
    flex-direction column
    height 100%
  .blank-page, .context
    display flex
    align-items center
    flex-direction column
    font-size 14px
    color #333333
  .loading-img
    height 24px
    width 24px
    margin 276px 0px 0px 0px
  .category-loading-center
    display flex
    flex-direction column
    justify-content center
    align-items center
    height 100%
  .category-loading-center-ios
    margin-top -62px
  .category-loading-img
    height 60px
    width 60px
  .title
    margin-top 16px
    line-height 20px
  .sub-title
    text-align center
    line-height 20px
  .blank-page .blank-img
    height 100px
    width 100px
    margin-top 120px
  .blank-button-Context
    font-size 13px
    padding 9px 27px
    margin-top 24px
    line-height 13px
    color #1473FF
    position relative
    border-color #1473FF
  .blank-button-Context:after
    content ''
    position absolute
    top -50%
    bottom -50%
    left -50%
    right -50%
    border 1px solid
    border-radius 6px
    box-sizing border-box
    transform scale(0.5)
  .loading-progress
    margin-top 16px
    height 8px
    width 100%
    display flex
    justify-content center
    margin-right 10px
  .circle
    width 8px
    height 8px
    border-radius 4px
    margin-left 10px
  .circle-normal
    background-color rgba(153, 153, 153, 0.2)
  .circle-current
    background-color #999999
</style>
<script name='json'>
  module.exports = {
    navigationBarTitleText: '主页',
    usingComponents: {}
  }
</script>



